import type {VersionId, VersionScanPlan} from "./2-ScanVersions.tsx"
import type {ScanContext} from "../scan-model/ScanContext.tsx";
import {downloadJobsExport, downloadJobsIndividually} from "./job/JobDownloadStrategy.ts";
import {scanJobDetails, type ScannedJobResult} from "./job/scanJobDetails.ts";

export interface ScannedVersionJobsResult {
    versionId: VersionId
    jobs: ScannedJobResult[]
}

export async function scanJobs(ctx: ScanContext, versionScan: VersionScanPlan): Promise<ScannedJobResult[]> {
    const {logError} = ctx

    const scanFunction = ctx.options.jobDownloadStrategy === "INDIVIDUAL" ? downloadJobsIndividually : downloadJobsExport

    try {
        return await scanFunction(ctx, versionScan, scanJobDetails)
    } catch (error) {
        logError(`Error scanning jobs in ${versionScan.id.groupName}/${versionScan.id.projectName}/${versionScan.id.versionName}.`, error)
        throw error
    }
}

export async function scanVersionsJobs(ctx: ScanContext, versions: VersionScanPlan[]): Promise<ScannedVersionJobsResult[]> {
    const {log, logError, startAction} = ctx
    const {reportOne, complete} = startAction(`Scanning jobs in ${versions.length} versions`, versions.length)
    const scannedJobs: ScannedVersionJobsResult[] = []
    for(const versionScan of versions) {
        try {
            const results = await scanJobs(ctx, versionScan)
            scannedJobs.push({
                versionId: versionScan.id,
                jobs: results
            })
            log(`Completed scanning jobs in ${versionScan.id.groupName}/${versionScan.id.projectName}/${versionScan.id.versionName}`)
        } catch(error) {
            logError(`Error scanning jobs in ${versionScan.id.groupName}/${versionScan.id.projectName}/${versionScan.id.versionName}.`, error)
        } finally {
            reportOne()
        }
    }
    ctx.log("Completed scanning jobs")
    complete()
    return scannedJobs
}